<template>
  <div>
    <p class="font-semibold">Popular Tags</p>
    <div
      v-for="(tag, idx) in popularTags"
      :key="idx"
      class="mb-4 flex items-center gap-2"
    >
      <div class="rounded-sm bg-green-800 p-2">
        <IconSparkles class="h-5 w-5 fill-grey-50" />
      </div>
      <NuxtLink :to="tag.link" class="no-underline hover:underline">{{
        tag.name
      }}</NuxtLink>
    </div>
  </div>
</template>

<script setup lang="ts">
const popularTags = [
  {
    name: "Getting Started",
    link: "/help-centre/tags/getting-started/",
  },
  {
    name: "Troubleshooting",
    link: "/help-centre/tags/troubleshooting/",
  },
  {
    name: "nbn",
    link: "/help-centre/tags/nbn/",
  },
  {
    name: "Residential",
    link: "/help-centre/tags/residential/",
  },
  {
    name: "Business",
    link: "/help-centre/tags/business/",
  },
  {
    name: "View all tags",
    link: "/help-centre/tags/",
  },
];
</script>
